import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import Spacer from 'design-system/components/Spacer';

const Container = styled.div`
  text-align: center;
`;

interface EmptyStateProps {
  productIcon: React.ReactElement;
}

const EmptyState: FC<PropsWithChildren<EmptyStateProps>> = ({ productIcon, children }) => {
  return (
    <Container>
      <Spacer height={3} />
      {productIcon}
      <Spacer height={2} />
      {children}
      <Spacer height={5} />
    </Container>
  );
};

export default EmptyState;
